module.exports = __webpack_public_path__ + "img/logo-pos.268bc49a.png";